import { Box, Container, Paper, Typography } from "@mui/material";
import React from "react";

function ErrorPage() {
  return (
    <Container>
      <Paper elevation={3}>
        <Box p={3} mt={3} align="center">
          <Typography variant="h1" color="error.main">
            404 Error
          </Typography>
          <Typography variant="paragraph" color="error.main.light">
            Requested resource not found.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default ErrorPage;
